import React,{Component} from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Button,
  
   
   } from "shards-react";
import { Redirect } from 'react-router';
import PageTitle from "../common/PageTitle";
import firebase from '../firebase';
import AddSubject from './AddSubject';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import ConfirmModal from '../ConfirmModal';


export default class Subject extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
        add_new_subject : false,
        subject_data :[],
        showConfirmModal:false,
        deletesubjectcode:null,
        logged_in : false,
    };

    this.ShowViewSubject = this.ShowViewSubject.bind(this);
    this.ShowAddSubject  = this.ShowAddSubject.bind(this);
    this.get_subject_data = this.get_subject_data.bind(this);
    this.setConfirmModalVisibility = this.setConfirmModalVisibility.bind(this);
    this.deletedata = this.deletedata.bind(this);


  }

  deletedata=(id)=>{
      var that = this;
      console.log(this.state);
      this.setState({loading:true,showConfirmModal:false});
      var func_ref = firebase.functions().httpsCallable('DeleteSubject');
                       
                       func_ref({subjectcode:this.state.deletesubjectcode}).then(function(result) {
                          // Read result of the Cloud Function.
                          var data = result.data;
                          console.log(data);

                          if(data.status==="success"){
                            console.log("Document successfully deleted!");
                            toast('Subject Successfully Deleted !', {containerId: 'A'});
                            that.setState({loading:false});
                            that.get_subject_data();
                          }
                          else{
                            toast('Unable to delete Subject!!', {containerId: 'A'});
                            that.setState({loading:false});
                            console.log(data.error.message);
                          }

                      }).catch(function(error) {
                                // Getting the Error details.
                                //var code = error.code;
                                var message = error.message;
                                //var details = error.details;
                                  // ...
                                console.log(message);
                                toast(message, {containerId: 'A'});
                                that.setState({loading:false});
                    });

    
  }



  get_subject_data = ()=>{
      var that = this;
      this.setState({loading:true});
      firebase.firestore().collection("Subject").doc('list').get().then(function(doc) {
          if(doc.exists){
            that.setState({subject_data:doc.data().list,loading:false});  
          }
          else{
            that.setState({subject_data:[],loading:false}); 
          }
          
      });

  }



  setConfirmModalVisibility =(data)=>{
      if(data==="close"){
        this.setState({showConfirmModal:false});
      }
      else{
          this.setState({showConfirmModal:true});
      }
  }


  ShowViewSubject = ()=>{
    this.setState({add_new_subject:false});
  }

  ShowAddSubject = ()=>{
    this.setState({add_new_subject:true});
  }

  componentDidMount(){
    this.get_subject_data();
  }

  componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }

	render(){

    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

			return (

	<Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Subjects" subtitle="All" className="text-sm-left" />
    </Row>

    <div style={{margin:"10px"}}>
          { 
            !this.state.add_new_subject &&
                <Button size="md" theme="info" className="mb-2 mr-1" onClick={()=>this.ShowAddSubject()}>
                    Add new Subject
              </Button>
          }

          {
            this.state.add_new_subject &&
              <Button size="md" theme="success" className="mb-2 mr-1" onClick={()=>this.ShowViewSubject()}>
                    View Subjects
              </Button>
          }
              
    </div>


    <Row>
      <Col>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            	<h6 className="m-1" >Subject </h6>	
          </CardHeader>
          
          <CardBody className="p-0 pb-3 scroll_list-group">

          { (!this.state.add_new_subject && !this.state.loading) &&

            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Subject Code
                  </th>
                  <th scope="col" className="border-0">
                    Subject Name
                  </th>
                 

                  <th scope="col" className="border-0">
                      Delete
                  </th>

                  
                </tr>
              </thead>
              <tbody>

               {
                    this.state.subject_data.map((item,i)=>{
                      return <TRow  data={item} 
                                    key={i} 
                                    index={i+1} 
                                    showconfirm={(id)=>{this.setState({deletesubjectcode:id});this.setConfirmModalVisibility('open');}}
                                    />
                    })
                  }
                
              </tbody>
            </table>

          }


            { this.state.add_new_subject && 

                        <div style={{height: '50%',width: '50%',marginLeft:"25%",borderWidth: 5,borderColor: 'black'}}>
                            <AddSubject cancel={this.ShowViewSubject} refresh={this.get_subject_data}/>
                      </div>

            }
            {
                 (!this.state.loading && (this.state.subject_data.length===0 && !this.state.add_new_subject)) &&
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center' }}>
                          {"No Subjects are Added"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "40%"}}>
                            <Button theme="info" size="lg" onClick={()=>{this.ShowAddSubject()}}>Add Subject</Button>
                        </div>                  
                    </div>
          }
          {
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />         
                    </div>
          }

       
          </CardBody>

        </Card>


        <ConfirmModal
            show={this.state.showConfirmModal}
            onHide={() =>this.setConfirmModalVisibility('close')}
            handleClose={() =>this.setConfirmModalVisibility('close')}
            onAccept={()=>this.deletedata(this.state.deleteclasscode)}
            message={"Are you Sure?\nThe data linked to this Subjects will be deleted permanently!"}
        />

      </Col>
    </Row>
    </Container>
		)
	}
}


class TRow extends Component{
  render(){
    return(
        <tr>
                  <td>{this.props.index}</td>
                  <td>{this.props.data.subjectcode}</td>
                  <td>{this.props.data.subjectname}</td>                  
                  <td style={{fontSize: 20,color:'red'}}
                      onClick={()=>{this.props.showconfirm(this.props.data.subjectcode)}}>
                      <i class="material-icons">delete</i>
                  </td>
        </tr>
    )
  }
}



